<div class="header">
    <h2>{{ 'instructors.modal.edit.title' | translate }}</h2>
    <button class="close" type="button" [attr.aria-label]="'common.close' | translate" data-test="instructors-edit-close" (click)="close()">
        <i class="pi pi-times"></i>
    </button>
</div>

@if (loading() !== false) {
    <div class="loading">
        <i class="pi pi-spin pi-spinner"></i>
    </div>
} @else if (error()) {
    <app-unavailable [message]="'instructors.error.unavailable' | translate" />
} @else if (instructor(); as instructor) {
    <form [formGroup]="form" (ngSubmit)="onSubmit()" class="body" autocomplete="off">
        <div class="section">
            <h2>{{ 'instructors.fieldset.personal' | translate }}</h2>
            <div class="profile">
                <app-form-avatar
                    [control]="form.controls.mediaImageId"
                    [label]="'instructors.form.image' | translate"
                    inputId="avatar"
                    [accept]="['image/*']"
                    testId="instructors-edit-avatar"
                />
                <div class="fields">
                    <div class="row">
                        <app-form-input
                            [control]="form.controls.firstName"
                            [label]="'instructors.form.firstName' | translate"
                            inputId="firstName"
                            testId="instructors-edit-first-name"
                        />
                        <app-form-input
                            [control]="form.controls.lastName"
                            [label]="'instructors.form.lastName' | translate"
                            inputId="lastName"
                            testId="instructors-edit-last-name"
                        />
                    </div>
                </div>
            </div>
        </div>

        <div class="section">
            <h2>{{ 'instructors.fieldset.credentials' | translate }}</h2>
            <app-form-input
                [control]="form.controls.degree"
                [label]="'instructors.form.degree' | translate"
                inputId="degree"
                testId="instructors-edit-degree"
            />
            <app-form-input
                [control]="form.controls.university"
                [label]="'instructors.form.university' | translate"
                inputId="university"
                testId="instructors-edit-university"
            />
        </div>
    </form>

    <div class="footer">
        <p-button
            [label]="'instructors.form.cancel' | translate"
            [outlined]="true"
            severity="secondary"
            data-test="instructors-edit-cancel"
            (onClick)="close()"
        />
        <p-button
            type="submit"
            [label]="'instructors.form.save' | translate"
            [loading]="saving()"
            [disabled]="form.disabled"
            data-test="instructors-edit-save"
            (onClick)="onSubmit()"
        />
    </div>
}
